import { Tab } from '../../../../../views/active-orders';

export default {
  title: 'Restaurant dashboard',
  tabs: {
    [Tab.OngoingOrders]: 'Prepare now',
    [Tab.FutureOrders]: 'Future',
    [Tab.CompleteOrders]: 'Completed',
  },
  buttons: {
    order_history: 'Order history',
  },
  feedback: {
    future_orders_alert: '⚠️ Do not prepare yet – we will let you know when you should start.',
  },
};
